import { Col, Row } from "antd";
import React, { useMemo, useRef } from "react";
import { isEmpty } from "lodash";
import { RangeSlider } from "./";
import { getAverageMinMax } from "../PolygonGenerator/DemographicPopulationDensity";

function Legends({
	legend = [],
	allSliders,
	sliderValue,
	selectedPolygonType,
	demographicFilterKeys,
	SocialMediaBehaviorsKeys,
	geo
}) {
	const prevMinMax = useRef({ min: 0, max: 0 });

	const tenantSlider = useMemo(() => {
		if (isEmpty(allSliders)) return <></>;
		const slider = allSliders[selectedPolygonType]?.[geo];

		const selectedSliderValue = sliderValue[selectedPolygonType];
		const inCellSitesCase = () => {
			const slider = allSliders["Comparison"]?.[geo] || {};
			const { min, max, sliderHandler, type, sliderType, isRange } = slider;
			if (!type) return <></>;
			const selectedSliderValue = sliderValue["Comparison"];
			return (
				<RangeSlider
					selectedValue={selectedSliderValue || [min, max]}
					key={`${type}-slider`}
					min={min}
					max={max}
					defaultValue={[min, max]}
					count={20}
					onSlide={value => sliderHandler(value)}
					step={(max - min) / 20}
					sliderType={sliderType}
					isRange={isRange}
				/>
			);
		};

		if (Array.isArray(slider)) {
			return (
				<>
					{slider.map((value, index) => {
						const sliderItem = value || {};
						const { min, max, sliderHandler, type, sliderType, isRange, ranges } = sliderItem;

						if (!type) return null; // Avoid rendering invalid sliders

						const selectedSliderValue = sliderValue[type];

						return (
							<Col span={24} key={`${type}-${index}`}>
								<RangeSlider
									key={`${type}-slider`}
									selectedValue={selectedSliderValue || [min, max]}
									min={min}
									max={max}
									defaultValue={selectedSliderValue}
									count={20}
									onSlide={value => sliderHandler(value)}
									step={(max - min) / 20}
									sliderType={sliderType}
									isRange={isRange}
									ranges={ranges}
								/>
							</Col>
						);
					})}
				</>
			);
		}

		if (!slider) return <></>;

		const {
			min: defaultMin,
			max: defaultMax,
			sliderHandler,
			type,
			sliderType,
			isRange,
			ranges,
			dynamicMinMax
		} = slider;
		const { min, max } = getAverageMinMax(
			demographicFilterKeys,
			dynamicMinMax,
			selectedPolygonType,
			{
				max: defaultMax,
				min: defaultMin
			},
			SocialMediaBehaviorsKeys
		);

		if (prevMinMax.current.min !== min || prevMinMax.current.max !== max) {
			if (min && max) {
				sliderHandler([min, max]);
			}
			// Update the ref with the new values
			prevMinMax.current = { min, max };
		}

		if (min == null || max == null) {
			return <></>;
		}
		return (
			<>
				<RangeSlider
					dynamicMinMax={dynamicMinMax}
					demographicFilterKeys={demographicFilterKeys}
					selectedValue={selectedSliderValue || [min, max]}
					key={`${type}-slider`}
					min={min}
					max={max}
					defaultValue={selectedSliderValue}
					count={20}
					onSlide={value => sliderHandler(value)}
					step={(max - min) / 20}
					sliderType={sliderType}
					isRange={isRange}
					ranges={ranges}
				/>
				{selectedPolygonType === "Cell Sites" && inCellSitesCase()}
			</>
		);
	}, [allSliders, sliderValue, selectedPolygonType, demographicFilterKeys, SocialMediaBehaviorsKeys]);

	return (
		<Row justify="center" align={"middle"}>
			<Col span={24}>
				<Row justify="center">
					{legend && legend.map(item => (isEmpty(item) ? <></> : <Col span={1.5}>{item}</Col>))}
				</Row>
			</Col>
			{tenantSlider && <Col span={23}>{tenantSlider}</Col>}
		</Row>
	);
}

export default Legends;
